(function() {
    'use strict';

    angular
        .module('madApp', [
            'ngStorage',
            'tmh.dynamicLocale',
            'pascalprecht.translate',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            // 'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'infinite-scroll',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            // 'angular-loading-bar',
            'angular.filter',
            'vljslib'
        ])
        .run(run);

    run.$inject = ['stateHandler', 'translationHandler','$rootScope', '$location'];

    function run(stateHandler, translationHandler,$rootScope, $location) {
        stateHandler.initialize();
        translationHandler.initialize();
        $rootScope.$location = $location;

        Highcharts.theme = {
          colors: [
            '#7cb5ec','#90ed7d','#59595a'
          ],}
          Highcharts.setOptions(Highcharts.theme);
    }
})();
